import React, { Component } from "react";
import locales from "../../../_constants/locales";
import "../Styles/NoMatch.css";

class NoMatch extends Component {
    render() {
        return (
            <section className="fit layout vertical center-center page-not-found">
                <h2>404</h2>
                <h3>{"PAGE NOT FOUND"}</h3>
                <span className="thick-divider" />
                <p className="description">{"Sorry! The page you're trying to find doesn't exist, or is temporarily unavailable."}</p>
                <p className="help-message">
                    {`${"Keep seeing this message? Go to"} `}
                    <a href={"https://help.kobo.com"} className="help-link">
                        {"help.kobo.com"}
                    </a>
                </p>
            </section>
        );
    }
}

export default NoMatch;
